import React from "react";
import { Box } from "@mui/material";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useAuth } from "../../context/AuthContext";
import LanguageDialog from "./language/LanguageDialog";
// import { PageTracker } from "../../components/PageTracker";

const FORCED_RESET_PATH = "/account/change-passcode/reset";

const BaseLayout: React.FC = () => {
  const { requiresPasswordChange } = useAuth();
  const location = useLocation();

  // While a forced password change is pending, redirect every route back to the
  // reset page so no header/footer/logo navigation can bypass the lock.
  if (requiresPasswordChange && location.pathname !== FORCED_RESET_PATH) {
    return <Navigate to={FORCED_RESET_PATH} replace />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      {/* <PageTracker /> */}
      <LanguageDialog />
      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          transition: "margin 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
          marginRight: {
            xs: 0,
          },
          minHeight: "auto",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Outlet />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default BaseLayout;